/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AuditLogBatchResponse {
    getFixupPrototypeFunction() { return AuditLogBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AuditLogBatchResponse>): AuditLogBatchResponse {
        let obj = Object.assign(new AuditLogBatchResponse(), model);
        AuditLogBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AuditLogBatchResponse>): AuditLogBatchResponse {
        if (!model) return null;
        return AuditLogBatchResponse.newInstance(<AuditLogBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AuditLogBatchResponse) {
        if (!obj) return;

        models.AuditLogBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AuditLogBatchResponse): boolean {
        Object.setPrototypeOf(obj, AuditLogBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AuditLogDocument.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AuditLogDocument; };

}
